import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useGetReminders } from '../../../Core/Hooks/useTimereport';
import { formatLocalDate } from '../../../Core/Utils/dateUtils';
import './TimereportRemindersList.scss';

type TimereportRemindersListProps = {
	hideEmptyList?: boolean;
};

const TimereportRemindersList = ({ hideEmptyList = false }: TimereportRemindersListProps) => {
	const { t } = useTranslation();
	const { reminders } = useGetReminders();

	const now = formatLocalDate(new Date());
	const activeReminders = useMemo(() => {
		if (!reminders) return [];
		return reminders.filter((r) => {
			if (r.visibleFrom && r.visibleFrom.split('T')[0] > now) return false;
			if (r.visibleTo && r.visibleTo.split('T')[0] < now) return false;
			return true;
		});
	}, [reminders, now]);

	if (hideEmptyList && activeReminders.length === 0) return null;

	return (
		<div className='biz-timereport-reminders-list'>
			<h3 className='biz-timereport-reminders-list__title'>
				{t('TIMEREPORT_USER.REPORT_VIEW.REMINDERS.TITLE')}
			</h3>
			{activeReminders.length === 0 && (
				<div className='biz-timereport-reminders-list__empty'>
					{t('TIMEREPORT_USER.REPORT_VIEW.REMINDERS.EMPTY')}
				</div>
			)}
			{activeReminders.map((r) => (
				<div key={r.id} className='biz-timereport-reminders-list__item'>
					<div className='biz-timereport-reminders-list__item-date'>
						{r.date.split('T')[0]}
					</div>
					<div className='biz-timereport-reminders-list__item-message'>
						{r.message}
					</div>
				</div>
			))}
		</div>
	);
};

export default TimereportRemindersList;
